import { named, withDependencies } from '@wix/thunderbolt-ioc'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'
import { PageFeatureConfigSymbol, SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import type { IPagesDefinition } from '@wix/viewer-service-pages/definition'
import { PagesDefinition as definition } from '@wix/viewer-service-pages/definition'
import { PagesService as impl } from '@wix/viewer-service-pages/implementations'
import { name } from './symbols'
import type { PagesServicePageConfig, PagesServiceSiteConfig } from './types'

const EMPTY_PAGES_CONFIG = { pages: {}, currentPageId: '', mainPageId: '' }

export const sitePagesService = withDependencies([], (): ServiceProvider<IPagesDefinition, typeof impl> => {
	return {
		definition,
		impl,
		config: EMPTY_PAGES_CONFIG,
		platformConfig: EMPTY_PAGES_CONFIG,
	}
})

export const pagesService = withDependencies(
	[named(PageFeatureConfigSymbol, name), named(SiteFeatureConfigSymbol, name)] as const,
	(
		pageFeatureConfig: PagesServicePageConfig,
		siteConfig: PagesServiceSiteConfig
	): ServiceProvider<IPagesDefinition, typeof impl> => {
		const config = {
			...pageFeatureConfig,
			mainPageId: siteConfig.mainPageId,
		}
		return {
			definition,
			impl,
			config,
			platformConfig: config,
		}
	}
)
